import { useEffect } from 'react';
import { useMe } from '@/lib/hooks';
import { startLive } from '@/lib/live';
import { navigate, useRoute } from '@/lib/router';
import { takeNotice } from '@/lib/session';
import { globalComponents } from '@/lib/slots';
import { toast } from '@/lib/toast';
import { DialogHost } from '@/ui/Dialog';
import { openAccount } from './AccountDialog';
import { GHint } from './GHint';
import { useGlobalKeys } from './globalKeys';
import { NotificationsPanel } from './NotificationsPanel';
import { Palette } from './Palette';
import { AdminSheetHost, RecordSheetHost } from './Sheets';
import { Topbar } from './Topbar';
import { ViewHost } from './ViewHost';

// The signed-in app: the top bar, the current view, the sheets and every layer that can open over them.

export function Shell() {
  const me = useMe();
  const { record, admin, params } = useRoute();
  const sample = me.user.passwordIsSample;
  const accountReturn = params.account;

  useEffect(() => startLive(), []);

  useEffect(() => {
    const notice = takeNotice();
    if (notice) toast(notice, { error: true });
  }, []);

  // Back from connecting Google in Your account (?account=google-linked, or ?account=google when it failed, with the
  // reason in the error toast): reopen the dialog where it started.
  useEffect(() => {
    if (!accountReturn) return;
    navigate({ params: { account: null } }, { replace: true });
    if (accountReturn === 'google-linked') toast('Google sign-in linked', { icon: 'check-circle' });
    openAccount();
  }, [accountReturn]);

  useEffect(() => {
    if (!sample) return;
    const t = setTimeout(() => {
      toast('You are using the sample password from setup', {
        icon: 'lock',
        error: true,
        action: { label: 'Change it', run: () => openAccount('password') },
      });
    }, 900);
    return () => clearTimeout(t);
  }, [sample]);

  useGlobalKeys();

  return (
    <>
      <Topbar />
      <main className={record || admin ? 'main under-sheet' : 'main'} id="main" tabIndex={-1}>
        <ViewHost />
      </main>
      <RecordSheetHost />
      <AdminSheetHost />
      <NotificationsPanel />
      <Palette />
      <GHint />
      <DialogHost />
      {globalComponents().map(([key, Component]) => (
        <Component key={key} />
      ))}
    </>
  );
}
